import { render } from "./RefundPolicyContent.vue?vue&type=template&id=65ed1bbb&scoped=true"
const script = {}

import "./RefundPolicyContent.vue?vue&type=style&index=0&id=65ed1bbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ed1bbb"]])

export default __exports__